import React, { Component } from 'react';
import { CheckboxInput } from '../shared/CheckboxInput.jsx'

export class ReportClassPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportListPortrait: [
        {id: 'regByClass', name: 'Entries by Class'},
        {id: 'resultsByClass', name: 'Results by Class'},
        {id: 'orderOfGo', name: 'Order of Go'},
        {id: 'howManyByClass', name: 'How Many by Class'},
      ],
      reportListLandscape: [
        {id: 'judgesCardHunter', name: 'Hunter & Equitation Judges Scorecards'},
        {id: 'judgesCardJumper', name: 'Jumper Judges Scorecards'}
      ]
    };
  }

  render() {
    var reportList = this.props.orientation === "Portrait" ?
                     this.state.reportListPortrait :
                     this.state.reportListLandscape
    return (
      <div className="form-horizontal pull-right">
        <h2>{`${this.props.orientation} Reports`}</h2>
        <div className="pull-right">
          { reportList.map((report) => 
            <CheckboxInput
              key={report.id}
              name={report.name}
              id={report.id}
              checked={this.props.reports[report.id]}
              onChange={this.props.onCheck}
             />
            )
          }
        </div>
      </div>
    );
  }
}
